/* globals functionality, login, rulesFlow, views, showModalError, showModalConfirm */
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Request from "common/Request";
import BqnContext from "common/BqnContext";
import { ShowPolicies } from "views/Status/Policies/Monitoring/component";
import { getPoliciesInRules } from "common/api";

const returnView = "viewRulesMonitor";

/*****************************************************
 * Radius-Rest Policies View
 * ****************************************************/
export const SubscriberMonitorPoliciesTable = () => {
  const [request, setRequest] = useState(null);
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  const doRequest = (mode, bqnId) => {
    const cliBqnSpec =
      mode === "standalone" || bqnId === "all" ? "" : ` bqn-id ${bqnId}`;
    return ifCl
      .run(
        `${[
          `show policy monitor statistics web${cliBqnSpec}`,
          "show config running all",
        ].join("\n")}\n`,
        /*is batch*/ true,
      )
      .then((response) => {
        const [policiesResponse, configResponse] = response.split(",");
        const rules = getPoliciesInRules(configResponse, "monitor");
        return { response: policiesResponse, rules };
      })
      .catch((error) => console.log(error));
  };


  const doLoad = (mode, bqnId) => {
    setRequest(doRequest(mode, bqnId));
  };

  useEffect(() => {
    doLoad(mode, bqnId);
  }, [mode, bqnId]);

  return request === null ? null : (
    <div className="row clearfix">
      <div className="body table-responsive">
        <Request during={request}>
          {(result) => <ShowPolicies {...result} reload={() => doLoad(mode, bqnId)} returnView={returnView} />}
        </Request>
      </div>
    </div>
  );
};
